import { useState } from 'react'
import { Button } from '../../components/ui'
import { formatDateInput } from '../../lib/format'

function MeetingForm({ onSubmit, onCancel, loading }) {
  const [meeting, setMeeting] = useState({
    title: '',
    date: formatDateInput(new Date().toISOString()),
    attendees: '',
    summary: '',
  })
  const [decisions, setDecisions] = useState([])
  const [actionItems, setActionItems] = useState([])

  const handleMeetingChange = (e) => {
    const { name, value } = e.target
    setMeeting(prev => ({ ...prev, [name]: value }))
  }

  const updateDecision = (index, field, value) => {
    setDecisions(prev => prev.map((item, idx) => idx === index ? { ...item, [field]: value } : item))
  }

  const updateActionItem = (index, field, value) => {
    setActionItems(prev => prev.map((item, idx) => idx === index ? { ...item, [field]: value } : item))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!meeting.title || !meeting.date) return

    const cleanDecisions = decisions.filter(item => item.title && item.decision)
    const cleanActions = actionItems.filter(item => item.description)

    onSubmit(meeting, cleanDecisions, cleanActions)
  }

  return (
    <form onSubmit={handleSubmit} className="stack">
      <div className="form-group">
        <label className="form-label">Title</label>
        <input
          className="form-input"
          name="title"
          value={meeting.title}
          onChange={handleMeetingChange}
          placeholder="Weekly Ops Sync"
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Date</label>
        <input
          className="form-input"
          type="date"
          name="date"
          value={meeting.date}
          onChange={handleMeetingChange}
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Attendees</label>
        <input
          className="form-input"
          name="attendees"
          value={meeting.attendees}
          onChange={handleMeetingChange}
          placeholder="Alex, Taylor, Sam"
        />
      </div>

      <div className="form-group">
        <label className="form-label">Summary</label>
        <textarea
          className="form-input"
          name="summary"
          value={meeting.summary}
          onChange={handleMeetingChange}
          rows={3}
        />
      </div>

      <div className="form-section">
        <div className="section-header">
          <h4>Decisions</h4>
          <Button type="button" variant="secondary" onClick={() => setDecisions(prev => [...prev, { title: '', context: '', decision: '', rationale: '', owner: '' }])}>
            + Add Decision
          </Button>
        </div>
        {decisions.map((decision, index) => (
          <div key={index} className="card-subtle">
            <div className="form-group">
              <label className="form-label">Title</label>
              <input className="form-input" value={decision.title} onChange={(e) => updateDecision(index, 'title', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Context</label>
              <textarea className="form-input" rows={2} value={decision.context} onChange={(e) => updateDecision(index, 'context', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Decision</label>
              <textarea className="form-input" rows={2} value={decision.decision} onChange={(e) => updateDecision(index, 'decision', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Rationale</label>
              <input className="form-input" value={decision.rationale} onChange={(e) => updateDecision(index, 'rationale', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Owner</label>
              <input className="form-input" value={decision.owner} onChange={(e) => updateDecision(index, 'owner', e.target.value)} />
            </div>
          </div>
        ))}
      </div>

      <div className="form-section">
        <div className="section-header">
          <h4>Action Items</h4>
          <Button type="button" variant="secondary" onClick={() => setActionItems(prev => [...prev, { description: '', owner: '', due_date: '', status: 'open' }])}>
            + Add Action Item
          </Button>
        </div>
        {actionItems.map((item, index) => (
          <div key={index} className="card-subtle">
            <div className="form-group">
              <label className="form-label">Description</label>
              <input className="form-input" value={item.description} onChange={(e) => updateActionItem(index, 'description', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Owner</label>
              <input className="form-input" value={item.owner} onChange={(e) => updateActionItem(index, 'owner', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Due Date</label>
              <input className="form-input" type="date" value={item.due_date} onChange={(e) => updateActionItem(index, 'due_date', e.target.value)} />
            </div>
          </div>
        ))}
      </div>

      <div className="modal-actions">
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" loading={loading}>
          Save Meeting
        </Button>
      </div>
    </form>
  )
}

export default MeetingForm
